import axiosClient from "./axiosClient";
import {Result} from "./types";
import {getTokenCookie} from "libs";
import axios from 'axios';

export class KaryaApi {
    config: any

    constructor() {
        const token = getTokenCookie()
        this.config = {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }
    }

    getKaryaList = async (offset: number): Promise<Result> => {
        return await axiosClient.get(`/management/paper/list/${offset}`, this.config)
    }
    getKaryaFilter = async (offset: number, title: string): Promise<Result> => {
        return await axiosClient.get(`/management/paper/filter/${offset}?title=${title}`, this.config)
    }
    getKaryaDetail = async (id: string): Promise<Result> => {
        return await axiosClient.get(`/papers/detail/${id}`, this.config)
    }
    deletePaper = async (data: any): Promise<Result> => {
        return await axiosClient.delete(`/management/paper/delete/${data}`, this.config);
    }

    postKaryaCreate = async (data: any): Promise<Result> => {
        return await axiosClient.post(`/management/papers/create`, data, this.config);
    }

    getPaperFeed = async (page: number): Promise<Result> => {
        return await axiosClient.get(`/papers/feed/${page}`, this.config)
    }
    getPaperFeedType = async (page: number, type: string): Promise<Result> => {
        return await axiosClient.get(`/papers/feed/type/${page}?papersType=${type}`, this.config)
    }
    getPaperFeedTitle = async (page: number, type: string): Promise<Result> => {
        return await axiosClient.get(`/papers/feed/title/${page}?title=${type}`, this.config)
    }
    getPaperFeedSubject = async (page: number, type: string): Promise<Result> => {
        return await axiosClient.get(`/papers/feed/subject/${page}?subject=${type}`, this.config)
    }
    getPaperLectureSubject = async (page: number, type: string): Promise<Result> => {
        return await axiosClient.get(`/papers/feed/lecture/${page}?lecture=${type}`, this.config)
    }

    postPaperRead = async (id: string): Promise<Result> => {
        return await axiosClient.post(`/papers/read/${id}`, {}, this.config);
    }

    uploadKarya = async (file: any): Promise<any> => {
        const formData = new FormData();
        formData.append('file', file);
        const {data} = await axios.post(`/api/uploads/ebooks`, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            },
            onUploadProgress: (event) => {
                console.log(`Current progress:`, Math.round((event.loaded * 100) / event.total));
            },
        });
        return data;
    }
}
